import useEntity from 'recoil/useEntity/useEntity'
import { IProjectRole } from '../projectRoles.types'
import projectRolesTableAtom from '../components/ProjectRolesTable/projectRolesTable.atom'
import projectRolesApi from '../projectRoles.api'

const useProjectRole = (id: IProjectRole['id']) => {
  const { entity, loading } = useEntity({
    atom: projectRolesTableAtom,
    entityId: id,
    itemFetcher: projectRolesApi.getOne,
    resource: 'projectRoles',
  })

  return { projectRole: entity, loading }
}

export default useProjectRole
